import Stack from "@mui/material/Stack";
import { JobRunDayField } from "@/features/job/job-run/JobRunDayField";
import type { JobRunSettingsProps } from "@/features/job/job-run/jobRun.types";
import { toJobRunInputWith, toJobRunText } from "@/features/job/job-run/jobRun.utils";

/** The Master order report's settings: the report's day, and how far back its orders go — both optional. */
export const JobRunBuildOrderLineReport = (props: JobRunSettingsProps) => {
  const { input, onChange } = props;

  const handleDateChange = (value: string) => {
    const next = toJobRunInputWith(input, "date", value);
    onChange(next);
  };

  const handleSinceChange = (value: string) => {
    const next = toJobRunInputWith(input, "since", value);
    onChange(next);
  };

  return (
    <Stack spacing={2}>
      <JobRunDayField
        disableFuture
        format="yyMMdd"
        helperText="Leave empty for today."
        label="Day (optional)"
        onChange={handleDateChange}
        value={toJobRunText(input, "date")}
      />
      <JobRunDayField
        format="yyyy-MM-dd"
        helperText="Leave empty for every order."
        label="Orders since (optional)"
        onChange={handleSinceChange}
        value={toJobRunText(input, "since")}
      />
    </Stack>
  );
};
